import React, { useState, useRef, useEffect, useMemo } from 'react';
import Select from 'react-dropdown-select';
import './LaceProduct.css';
import config from '../config';

const LaceProduct = ({ product, onOrderDataChange, isReadOnly = false, secimData = null, showRecycle = false, showMaxRecycle = false }) => {
    //  console.log('LaceProduct showRecycle prop:', showRecycle);
    // console.log('LaceProduct showMaxRecycle prop:', showMaxRecycle);

    const [selectedImage, setSelectedImage] = useState(null); // Seçili resim
    const [showMagnifier, setShowMagnifier] = useState(false);
    const [magnifierPosition, setMagnifierPosition] = useState({ x: 0, y: 0 });
    const [imageFormat, setImageFormat] = useState('jpg');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [zoomLevel, setZoomLevel] = useState(1);
    const [showModalMagnifier, setShowModalMagnifier] = useState(false);
    const [modalMagnifierPosition, setModalMagnifierPosition] = useState({ x: 0, y: 0 });
    const [orderSubType, setOrderSubType] = useState('');
    const [quantityUnit, setQuantityUnit] = useState('');
    const [quantity, setQuantity] = useState('');
    const [selectedOrderColors, setSelectedOrderColors] = useState([]);
    const imageRef = useRef(null);
    const modalImageRef = useRef(null);

    const cacheBuster = Math.floor(Date.now() / 120000);

    // Küçük resim büyüteç ayarları
    const MAGNIFIER_SIZE = 400; // Büyüteç boyutu (piksel)
    const ZOOM_LEVEL = 1.3; // Büyütme oranı

    // Modal büyüteç ayarları
    const MODAL_MAGNIFIER_SIZE = 400; // Modal büyüteç boyutu (piksel)
    const MODAL_ZOOM_LEVEL = 0.5; // Modal büyütme oranı

    const handleMouseMove = (e) => {
        if (!imageRef.current) return;

        const rect = imageRef.current.getBoundingClientRect();

        // Mouse'un resim içindeki pozisyonu
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;

        // Yüzdelik pozisyonu hesapla
        const x = (mouseX / rect.width) * 100;
        const y = (mouseY / rect.height) * 100;

        setMagnifierPosition({
            x,
            y,
            mouseX: e.clientX - MAGNIFIER_SIZE / 2,
            mouseY: e.clientY - MAGNIFIER_SIZE / 2
        });

        // Eğer büyüteç kapalıysa ve mouse resmin üzerindeyse, aç
        if (!showMagnifier && !isModalOpen) {
            setShowMagnifier(true);
        }
    };

    const handleModalMouseMove = (e) => {
        if (!modalImageRef.current) return;

        const rect = modalImageRef.current.getBoundingClientRect();

        // Mouse'un resim içindeki pozisyonu
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;

        // Yüzdelik pozisyonu hesapla
        const x = (mouseX / rect.width) * 100;
        const y = (mouseY / rect.height) * 100;

        setModalMagnifierPosition({
            x,
            y,
            mouseX: e.clientX - MODAL_MAGNIFIER_SIZE / 2,
            mouseY: e.clientY - MODAL_MAGNIFIER_SIZE / 2
        });
    };

    // Renk bilgileri product ile birlikte geliyor
    const colorData = product.RENK_BILGILERI || [];
    const katalogResimleri = product.KATALOG_RESIMLERI || [];
    const hareketliResimler = useMemo(() => product.HAREKETLI_RESIMLER || [], [product.HAREKETLI_RESIMLER]);
    const fiyatBilgileri = product.FIYAT_BILGILERI || [];
    const leftoversData = product.LEFTOVERS_BILGILERI || [];

    // Recycle bilgisini kontrol et
    if (showRecycle || showMaxRecycle) {
        // console.log('Product Data:', product);
        // console.log('KOMPOZISYON_RYC:', product.KOMPOZISYON_RYC);
        // console.log('KOMPOZISYON_MAXRYC:', product.KOMPOZISYON_MAXRYC);
    }

    // Hareketli resim varsa ilk yüklemede onu göster
    /*  useEffect(() => {
          if (hareketliResimler.length > 0 && !selectedImage) {
              const firstImage = `${config.IMAGE_BASE_URL}/images2/Hareketli/${product.ESKI_DESEN}/desensmall/${hareketliResimler[0].DOSYA_ADI}?t=${cacheBuster}`;
              setSelectedImage(firstImage);
          }
      }, [hareketliResimler, product.DENEME_NO, selectedImage, product.ESKI_DESEN, cacheBuster]);
    */

    // Form değişikliklerini parent'a bildir
    useEffect(() => {
        if (onOrderDataChange) {
            onOrderDataChange(product.DENEME_NO, {
                renk: selectedOrderColors,
                tip: orderSubType,
                miktar: quantity,
                birim: quantityUnit
            });
        }
    }, [selectedOrderColors, orderSubType, quantity, quantityUnit, product.DENEME_NO, onOrderDataChange]);

    const handleZoomIn = () => {
        setZoomLevel(prev => Math.min(prev + 0.5, 3));
    };

    const handleZoomOut = () => {
        setZoomLevel(prev => Math.max(prev - 0.5, 1));
    };

    const handleFullscreen = () => {
        if (modalImageRef.current) {
            if (modalImageRef.current.requestFullscreen) {
                modalImageRef.current.requestFullscreen();
            } else if (modalImageRef.current.webkitRequestFullscreen) {
                modalImageRef.current.webkitRequestFullscreen();
            } else if (modalImageRef.current.msRequestFullscreen) {
                modalImageRef.current.msRequestFullscreen();
            }
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setZoomLevel(1);
        setShowModalMagnifier(false);
        setModalMagnifierPosition({ x: 0, y: 0 });
    };

    // Scroll yapıldığında büyüteci kapat
    useEffect(() => {
        const handleScroll = () => {
            if (showMagnifier) {
                setShowMagnifier(false);
            }
            if (showModalMagnifier) {
                setShowModalMagnifier(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [showMagnifier, showModalMagnifier]);

    const renderSpecRow = (label, value) => {
        //if (!value) return null;
        return (
            <div className="spec-row">
                <span>{label}</span>
                <span>{value}</span>
            </div>
        );
    };

    return (
        <div className="product-card">
            <div className="product-left">
                {product.ESKI_DESEN && (
                    <div className="image-section">
                        <div
                            className="product-image-container"
                            onMouseEnter={() => setShowMagnifier(true)}
                            onMouseLeave={() => setShowMagnifier(false)}
                            onMouseMove={handleMouseMove}
                            onClick={() => {
                                setShowMagnifier(false);
                                setIsModalOpen(true);
                            }}
                            style={{ cursor: 'pointer' }}
                        >
                            <img
                                ref={imageRef}
                                src={selectedImage || `${config.IMAGE_BASE_URL}/images2/desensmall/${product.ESKI_DESEN}.${imageFormat}?t=${cacheBuster}`}
                                alt={`Dantel ${product.DESEN}`}
                                className="product-image"
                                onError={(e) => {
                                    if (imageFormat === 'jpg') {
                                        setImageFormat('bmp');
                                    }
                                }}
                            />
                        </div>
                        {showMagnifier && !isModalOpen && imageRef.current && magnifierPosition.mouseX !== undefined && (
                            <div
                                className="magnifier"
                                style={{
                                    position: 'fixed',
                                    left: `${magnifierPosition.mouseX}px`,
                                    top: `${magnifierPosition.mouseY}px`,
                                    backgroundImage: `url(${selectedImage ? selectedImage.replace('/desensmall/', '/desensmall/') : `${config.IMAGE_BASE_URL}/images2/desensmall/${product.ESKI_DESEN}.${imageFormat}?t=${cacheBuster}`})`,
                                    backgroundPosition: `${magnifierPosition.x}% ${magnifierPosition.y}%`,
                                    width: `${MAGNIFIER_SIZE}px`,
                                    height: `${MAGNIFIER_SIZE}px`,
                                    backgroundSize: `${imageRef.current.width * ZOOM_LEVEL}px ${imageRef.current.height * ZOOM_LEVEL}px`
                                }}
                            />
                        )}
                    </div>
                )}

                {/* Hareketli Resimler - Sol Alt Köşe */}
                {hareketliResimler.length > 0 && (
                    <div className="hareketli-resimler-container">
                        {/* Ana resmin küçük hali */}
                        {product.ESKI_DESEN && (
                            <div
                                className="hareketli-resim-item"
                                onClick={() => setSelectedImage(`${config.IMAGE_BASE_URL}/images2/desensmall/${product.ESKI_DESEN}.${imageFormat}?t=${cacheBuster}`)}
                            >
                                <img
                                    src={`${config.IMAGE_BASE_URL}/images2/desensmall/${product.ESKI_DESEN}.${imageFormat}?t=${cacheBuster}`}
                                    alt="Ana Resim"
                                    className="hareketli-resim"
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                    }}
                                />
                            </div>
                        )}
                        {/* Diğer hareketli resimler */}
                        {hareketliResimler.map((resim, index) => {
                            const imageUrl = `${config.IMAGE_BASE_URL}/images2/Hareketli/${product.ESKI_DESEN}/desensmall/${resim.DOSYA_ADI}?t=${cacheBuster}`;
                            return (
                                <div
                                    key={index}
                                    className="hareketli-resim-item"
                                    onClick={() => setSelectedImage(imageUrl)}
                                >
                                    <img
                                        src={imageUrl}
                                        alt={`Hareketli ${index + 1}`}
                                        className="hareketli-resim"
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                        }}
                                    />
                                </div>
                            );
                        })}
                    </div>
                )}

                {/* Sipariş Formu veya Seçili Veriler */}
                {colorData.length > 0 && !isReadOnly && (
                    <div className="order-form-section">
                        <div className="order-form-row">
                            <Select
                                multi
                                options={colorData.map(color => ({
                                    value: color.MUSTERI_RENK_ADI || color.ANA_RENKLER_ING,
                                    label: color.MUSTERI_RENK_ADI || color.ANA_RENKLER_ING
                                }))}
                                values={selectedOrderColors}
                                onChange={(values) => setSelectedOrderColors(values)}
                                labelField="label"
                                valueField="value"
                                searchable={false}
                                dropdownHandle={true}
                                dropdownHeight="auto"
                                className="order-dropdown"
                                placeholder="Choose..."
                                contentRenderer={({ props }) => {
                                    return props.values.length
                                        ? `${props.values.length} Selected`
                                        : "Choose...";
                                }}
                                itemRenderer={({ item, itemIndex, props, state, methods }) => (
                                    <div className="dropdown-item">
                                        <input
                                            type="checkbox"
                                            checked={!!state.values.find(val => val.value === item.value)}
                                            onChange={() => methods.addItem(item)}
                                        />
                                        <span>{item.label}</span>
                                    </div>
                                )}
                            />

                            <Select
                                options={[
                                    { value: '', label: 'Choose...' },
                                    { value: 'hanger', label: 'Hanger' },
                                    { value: 'sample', label: 'Sample' }
                                ]}
                                values={orderSubType ? [{ value: orderSubType, label: orderSubType }] : []}
                                onChange={(values) => setOrderSubType(values[0]?.value || '')}
                                labelField="label"
                                valueField="value"
                                searchable={false}
                                dropdownHandle={true}
                                className="order-dropdown"
                                placeholder="Choose..."
                            />

                            <input
                                type="text"
                                className="order-input"
                                placeholder="Quantity"
                                value={quantity}
                                onChange={(e) => setQuantity(e.target.value)}
                                onKeyPress={(e) => {
                                    // Sadece sayı, nokta ve virgül kabul et
                                    if (!/[0-9.,]/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                            />

                            <Select
                                options={[
                                    { value: '', label: 'Choose...' },
                                    { value: 'm', label: 'm' },
                                    { value: 'yd', label: 'yd' },
                                    { value: 'pcs', label: 'pcs' }
                                ]}
                                values={quantityUnit ? [{ value: quantityUnit, label: quantityUnit }] : []}
                                onChange={(values) => setQuantityUnit(values[0]?.value || '')}
                                labelField="label"
                                valueField="value"
                                searchable={false}
                                dropdownHandle={true}
                                className="order-dropdown order-dropdown-small"
                                placeholder="Choose..."
                            />
                        </div>
                    </div>
                )}

                {/* Seçili Veriler (ReadOnly Mode) */}
                {isReadOnly && secimData && (
                    <div className="selected-order-info">
                        <div className="selected-info-row">
                            <span className="selected-label">Selected Colors:</span>
                            <span className="selected-value">{secimData.renk?.join(', ')}</span>
                        </div>
                        <div className="selected-info-row">
                            <span className="selected-label">Type:</span>
                            <span className="selected-value">{secimData.tip}</span>
                        </div>
                        <div className="selected-info-row">
                            <span className="selected-label">Quantity:</span>
                            <span className="selected-value">{secimData.miktar} {secimData.birim}</span>
                        </div>
                    </div>
                )}

                {/* Modal */}
                {isModalOpen && (
                    <div className="image-modal" onClick={handleCloseModal}>
                        <div className="modal-controls">
                            <button className="modal-btn zoom-out" onClick={(e) => { e.stopPropagation(); handleZoomOut(); }} title="Uzaklaştır" disabled={zoomLevel <= 1} style={{ display: 'none' }}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="11" cy="11" r="8" />
                                    <path d="M21 21l-4.35-4.35" />
                                    <line x1="8" y1="11" x2="14" y2="11" />
                                </svg>
                            </button>
                            <button className="modal-btn zoom-in" onClick={(e) => { e.stopPropagation(); handleZoomIn(); }} title="Yakınlaştır" disabled={zoomLevel >= 3} style={{ display: 'none' }}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="11" cy="11" r="8" />
                                    <path d="M21 21l-4.35-4.35" />
                                    <line x1="11" y1="8" x2="11" y2="14" />
                                    <line x1="8" y1="11" x2="14" y2="11" />
                                </svg>
                            </button>
                            <button className="modal-btn fullscreen" onClick={(e) => { e.stopPropagation(); handleFullscreen(); }} title="Tam Ekran">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
                                </svg>
                            </button>
                            <button className="modal-btn close" onClick={(e) => { e.stopPropagation(); handleCloseModal(); }} title="Kapat">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <line x1="18" y1="6" x2="6" y2="18" />
                                    <line x1="6" y1="6" x2="18" y2="18" />
                                </svg>
                            </button>
                        </div>
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                            <div
                                className="modal-image-container"
                                onMouseEnter={() => setShowModalMagnifier(true)}
                                onMouseLeave={() => setShowModalMagnifier(false)}
                                onMouseMove={handleModalMouseMove}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setZoomLevel(zoomLevel === 1 ? 1.5 : 1);
                                }}
                                style={{ cursor: 'pointer' }}
                            >
                                <img
                                    ref={modalImageRef}
                                    src={selectedImage ? selectedImage.replace('/desensmall', '/') : `${config.IMAGE_BASE_URL}/images2/${product.ESKI_DESEN}.${imageFormat}?t=${cacheBuster}`}
                                    alt={`Dantel ${product.DESEN}`}
                                    className="modal-image"
                                    style={{ transform: `scale(${zoomLevel})`, transition: 'transform 0.2s ease' }}
                                />
                            </div>
                            {showModalMagnifier && modalImageRef.current && modalMagnifierPosition.mouseX !== undefined && (
                                <div
                                    className="modal-magnifier"
                                    style={{
                                        position: 'fixed',
                                        left: `${modalMagnifierPosition.mouseX}px`,
                                        top: `${modalMagnifierPosition.mouseY}px`,
                                        backgroundImage: `url(${selectedImage ? selectedImage.replace('/desensmall/', '/') : `${config.IMAGE_BASE_URL}/images2/${product.ESKI_DESEN}.${imageFormat}?t=${cacheBuster}`})`,
                                        backgroundPosition: `${modalMagnifierPosition.x}% ${modalMagnifierPosition.y}%`,
                                        width: `${MODAL_MAGNIFIER_SIZE}px`,
                                        height: `${MODAL_MAGNIFIER_SIZE}px`,
                                        backgroundSize: `${modalImageRef.current.naturalWidth * MODAL_ZOOM_LEVEL * zoomLevel}px ${modalImageRef.current.naturalHeight * MODAL_ZOOM_LEVEL * zoomLevel}px`
                                    }}
                                />
                            )}
                        </div>
                        <div className="modal-info">{product.DENEME_NO}</div>
                    </div>
                )}

            </div>

            <div className="product-info">
                {product.DENEME_NO && (
                    <>
                        <h2 className="product-title">{product.BASLIK_ELASTIC}</h2>
                        <div className="article-no">Article No: {product.DENEME_NO}</div>
                    </>
                )}

                <div className="specifications">
                    {renderSpecRow('Width', product.KUMAS_ENI + '  cm + / -  %' + product.KUMAS_ENI_ARTIEKSI + ' from top to top')}
                    {renderSpecRow('Elasticity', product.ELASTIC)}
                    {renderSpecRow('Composition', product.KOMPOZISYON)}
                    {showRecycle && renderSpecRow('Recycle Composition Estimation', product.KOMPOZISYON_RYC)}
                    {showMaxRecycle && renderSpecRow('Recycle Composition Estimation', product.KOMPOZISYON_MAXRYC)}
                    {renderSpecRow('Moq/Mcq', product.MINMIKTAR)}
                    {renderSpecRow('Scallop info', product.ETEK_BILGISI || '')}
                    {renderSpecRow('Weight', product.GRAMAJ_MTUL + ' gr/mtull')}
                    {renderSpecRow('Product Style', product.STR_KUPON)}

                    {fiyatBilgileri.length > 0 && (
                        <div className="min-quantity-section">
                            <table className="min-quantity-table">
                                <thead>
                                    <tr>
                                        <th>Min. Quantity</th>
                                        <th>Price</th>
                                        <th>Price Recycle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {fiyatBilgileri.map((fiyat, index) => (
                                        <tr key={index}>
                                            <td className="quantity-cell">{fiyat.DSN_MINSIPMIKTAR}</td>
                                            <td className="price-cell">{fiyat.GORUS_FIYAT} {fiyat.GORUS_BIRIM}</td>
                                            <td className="price-recycle-cell">{fiyat.ALAN_1}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {colorData.length > 0 && (
                        <div className="spec-row colors-row">
                            <span>Available Colors</span>
                            <span>
                                <div className="available-colors">
                                    {colorData.map((color, index) => (
                                        <div key={index} className="color-stock-item">
                                            <span className="color-name">{color.ANA_RENKLER_ING || color.MUSTERI_RENK_ADI}</span>
                                            <span className="stock-info">Stock: {Math.round(color.KALAN)} m</span>
                                        </div>
                                    ))}
                                </div>
                            </span>
                        </div>
                    )}

                    {leftoversData.length > 0 && (
                        <div className="spec-row colors-row">
                            <span>Leftovers</span>
                            <span>
                                <div className="available-colors">
                                    {leftoversData.map((color, index) => (
                                        <div key={index} className="color-stock-item">
                                            <span className="color-name">{color.ANA_RENKLER_ING || color.MUSTERI_RENK_ADI}</span>
                                            <span className="stock-info">Stock: {Math.round(color.KALAN)} m</span>
                                        </div>
                                    ))}
                                </div>
                            </span>
                        </div>
                    )}

                    {katalogResimleri.length > 0 && (
                        <div className="katalog-resimleri-container">
                            {katalogResimleri.filter(resim =>
                                colorData.some(color =>
                                    color.ANA_RENKLER_ING === resim.RENK_ADI ||
                                    color.MUSTERI_RENK_ADI === resim.RENK_ADI
                                )
                            ).map((resim, index) => (
                                <div key={index} className="katalog-resim-item">
                                    <img
                                        src={`${config.IMAGE_BASE_URL}/images2/Katalog/${product.DENEME_NO}/thumb/${resim.DOSYA_ADI}?t=${cacheBuster}`}
                                        alt={resim.RENK_ADI || 'Katalog'}
                                        className="katalog-resim"
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                        }}
                                    />
                                    {resim.RENK_ADI && (
                                        <div className="katalog-resim-label">{resim.RENK_ADI}</div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}

                    {product.YTALIMAT && (
                        <img
                            style={{ marginLeft: '40px', marginTop: '20px', width: '250px' }}
                            src={`${config.IMAGE_BASE_URL}/images/${product.YTALIMAT}.png?v=2`}
                            alt="Yatırım Talimatı"
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default LaceProduct; 